import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ImageViewerProvider } from './hooks/useImageViewer';
import ScrollToTop from './utils/ScrollToTop';
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');
const app = (
  <HelmetProvider>
    <React.StrictMode>
      <ImageViewerProvider>
        <BrowserRouter>
          <ScrollToTop />
          <App />
        </BrowserRouter>
      </ImageViewerProvider>
    </React.StrictMode>
  </HelmetProvider>
);

// react-snap pre-rendered HTML stays in the DOM for fast first paint / SEO.
// We use createRoot (not hydrateRoot) to avoid hydration mismatches from
// client-side-only components (Swiper breakpoints, window.innerWidth, etc.).
ReactDOM.createRoot(rootElement).render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// Skip during react-snap pre-rendering (userAgent = "ReactSnap"): puppeteer can't serialize async console args before page closes
if (!/ReactSnap/.test(navigator.userAgent)) {
  reportWebVitals(console.log);
}
